// src/checklist/index.js — екран „Чек лист" (Фаза 3.2). Пренесен дословно от app.js.
// Калкулаторите се ползват ДИРЕКТНО от модула им (не през window моста).

import { el, clear, $, field, input } from '../shared/dom.js';
import { dfmt } from '../shared/format.js';
import { dateInput } from '../shared/dates.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { emptyState, loadError, tabBar } from '../shared/ui.js';
import { openModal, closeModal, confirmDialog } from '../shared/modal.js';
import { whenFmt, auditBlock } from '../shared/audit.js';
import { state, cq, isAdminUser } from '../shared/state.js';
import { openCalc, CALC_LABELS } from '../calculators/index.js';
import { CHECKLIST_TEMPLATE } from './template.js';
import { render as renderBlanka } from './blanka.js';

let _checkYear = String(new Date().getFullYear());
let _mode = 'points'; // 'points' (сегашният) | 'blanka' (работна бланка)

// Превключвател на изгледа — стои най-отгоре и в двата режима.
function viewSwitcher(page) {
  return tabBar([{ id: 'points', label: 'По точки' }, { id: 'blanka', label: 'Работна бланка' }],
    _mode, (id) => { _mode = id; view(page); }, 'Изглед на чек листа');
}

export async function view(page) {
  clear(page);
  page.appendChild(viewSwitcher(page));
  if (_mode === 'blanka') { await renderBlanka(page); return; }
  if (!state().activeCompany) return window.CRM.needsCompany(page);
  let items = [];
  try { items = await api('/checklist' + cq() + '&year=' + _checkYear); }
  catch (e) { page.appendChild(loadError(() => view(page))); return; }
  const panel = el('div', { class: 'panel' });
  const cy = new Date().getFullYear();
  const years = [...new Set([...items.map((i) => String(i.year)), String(cy), String(cy - 1), String(cy + 1)])].sort().reverse();
  if (!years.includes(_checkYear)) years.unshift(_checkYear);
  const yearSel = el('select', { onChange: (e) => { _checkYear = e.target.value; view($('#page')); } }, ...years.map((y) => el('option', { value: y, text: 'Година ' + y, selected: y === _checkYear })));
  const done = items.filter((i) => i.done).length;
  const head = el('div', { class: 'panel-head' },
    el('h2', { text: 'Чек лист' }), yearSel,
    el('span', { style: 'color:var(--muted);font-size:13px;margin-left:auto', text: done + ' от ' + items.length + ' готови' }),
    el('button', { class: 'btn sm ghost', text: 'Зареди шаблон', onClick: () => loadChecklistTemplate(items) }),
    el('button', { class: 'btn sm', text: '+ Нова точка', onClick: () => checklistItemForm(null) })
  );
  panel.appendChild(head);
  const pct = items.length ? Math.round(done / items.length * 100) : 0;
  panel.appendChild(el('div', { style: 'height:8px;background:var(--surface-2,#eee);border-radius:6px;overflow:hidden;margin:2px 0 14px' }, el('div', { style: 'height:100%;width:' + pct + '%;background:var(--green,#16a34a);transition:width .2s' })));
  if (!items.length) { panel.appendChild(emptyState('☑', 'Още няма точки за ' + _checkYear + '. Добавете първата.', '+ Нова точка', () => checklistItemForm(null))); page.appendChild(panel); return; }
  const groups = {};
  items.forEach((i) => { const s = i.section || 'Общи'; (groups[s] = groups[s] || []).push(i); });
  Object.keys(groups).forEach((sec) => {
    panel.appendChild(el('h4', { text: sec, style: 'margin:14px 0 4px;color:var(--muted);font-size:13px;text-transform:uppercase;letter-spacing:.5px' }));
    groups[sec].sort((a, b) => (a.sort || 0) - (b.sort || 0)).forEach((it) => {
      const cb = el('input', { type: 'checkbox', checked: !!it.done, onClick: async () => { try { await api('/checklist/' + it.id + '/toggle', { method: 'PATCH' }); view($('#page')); } catch (err) { toast(err.message, true); } } });
      const meta = (it.done && it.done_by_name) ? el('div', { style: 'font-size:12px;color:var(--green,#16a34a);margin-top:2px', text: '✓ ' + it.done_by_name + ' · ' + whenFmt(it.done_at) }) : null;
      // Падежът (сървърът го изчислява): таг + „реален срок", ако е изместен
      // към работен ден. Просрочените неотметнати светят в червено.
      let dueTag = null;
      if (it.due && !it.done) {
        const today = new Date(); const pad = (n) => (n < 10 ? '0' : '') + n;
        const todayIso = today.getFullYear() + '-' + pad(today.getMonth() + 1) + '-' + pad(today.getDate());
        const overdue = (it.due_effective || it.due) < todayIso;
        dueTag = el('div', { style: 'margin-top:3px;display:flex;gap:6px;align-items:center;flex-wrap:wrap' },
          el('span', { class: 'tag ' + (overdue ? 'red' : 'purple'), text: 'до ' + dfmt(it.due) }),
          (it.due_effective && it.due_effective !== it.due)
            ? el('span', { style: 'font-size:12px;color:var(--muted)', text: 'реален срок: ' + dfmt(it.due_effective) + ' (следващият работен ден)' })
            : null);
      }
      panel.appendChild(el('div', { style: 'display:flex;gap:10px;align-items:flex-start;padding:9px 4px;border-bottom:1px solid var(--border)' },
        el('label', { style: 'cursor:pointer;margin-top:2px' }, cb),
        el('div', { style: 'flex:1', onClick: () => checklistItemForm(it) },
          el('div', { style: it.done ? 'text-decoration:line-through;color:var(--muted);cursor:pointer' : 'cursor:pointer', text: it.text }),
          it.note ? el('div', { style: 'font-size:12px;color:var(--muted);margin-top:2px', text: it.note }) : null,
          dueTag,
          meta),
        (it.calc && CALC_LABELS[it.calc]) ? el('button', { class: 'btn sm', title: 'Отвори калкулатора: ' + CALC_LABELS[it.calc], 'aria-label': 'Калкулатор: ' + CALC_LABELS[it.calc], onClick: (e) => { e.stopPropagation(); openCalc(it.calc); } }, el('span', { 'aria-hidden': 'true', text: '∑ ' }), el('span', { text: 'Калкулатор' })) : null,
        el('button', { class: 'btn sm ghost', title: 'Промени точката', 'aria-label': 'Промени: ' + it.text, onClick: () => checklistItemForm(it) }, el('span', { 'aria-hidden': 'true', text: '✎ ' }), el('span', { text: 'Промени' })),
        isAdminUser() && el('button', { class: 'btn sm danger row-del', title: 'Изтрий точката', 'aria-label': 'Изтрий: ' + it.text, onClick: async () => { if (await confirmDialog('Да изтрия ли тази точка?', { okText: 'Изтрий', danger: true })) { try { await api('/checklist/' + it.id, { method: 'DELETE' }); view($('#page')); } catch (e) { toast('Изтриването не се получи. ' + e.message, true); } } } }, el('span', { text: 'Изтрий' }))
      ));
    });
  });
  page.appendChild(panel);
}

const MONTH_NAMES = ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'];

// Разпознава „До 31 януари" / „31.01" от свободния текст — само за
// ПРЕДЛОЖЕНИЕ във формата (сървърът има същото правило за старите записи).
function parseDueHint(text) {
  const s = String(text || '').toLowerCase();
  let m = s.match(/(\d{1,2})[- ]*(?:во|ви|ти|ри)?\s+(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/);
  if (m) return { day: Number(m[1]), month: MONTH_NAMES.indexOf(m[2]) + 1 };
  m = s.match(/(?:^|[^\d.])(\d{1,2})[.\/](\d{1,2})(?:[^\d]|$)/);
  if (m && Number(m[2]) >= 1 && Number(m[2]) <= 12) return { day: Number(m[1]), month: Number(m[2]) };
  return null;
}

function checklistItemForm(existing) {
  const it = existing || {};
  // Предложение: ако точката няма въведен падеж, но текстът в „Раздел/срок"
  // съдържа дата — попълваме я отнапред (потребителят може да я изтрие).
  const hint = (!it.due_day && !it.due_date) ? parseDueHint(it.section) : null;
  const f = {
    section: input({ value: it.section || '', placeholder: 'Раздел (по избор, напр. Годишни декларации)' }),
    text: el('textarea', { placeholder: 'Текст на точката…' }, it.text || ''),
    note: input({ value: it.note || '', placeholder: 'Бележка (по избор)' }),
    calc: el('select', {}, el('option', { value: '', text: '— без калкулатор —' }), ...Object.keys(CALC_LABELS).map((k) => el('option', { value: k, text: CALC_LABELS[k], selected: (it.calc || '') === k }))),
    dueDay: input({ type: 'number', min: '1', max: '31', value: it.due_day || (hint && hint.day) || '', placeholder: 'ден', style: 'max-width:90px' }),
    dueMonth: el('select', {}, el('option', { value: '', text: '— месец —' }), ...MONTH_NAMES.map((nm, i) =>
      el('option', { value: i + 1, text: nm, selected: (Number(it.due_month) || (hint && hint.month)) === i + 1 }))),
    dueDate: dateInput(it.due_date || ''),
  };
  // (Г.8) Трите полета в един ред караха човек да гадае кое с кое върви.
  // Радио: видът срок се ИЗБИРА, полетата на другите видове са скрити.
  const dueKind = (it.due_day || (hint && hint.day)) ? 'yearly' : (it.due_date ? 'once' : 'none');
  const rName = 'chk-due-' + (it.id || 'new');
  const rNone = el('input', { type: 'radio', name: rName, value: 'none', checked: dueKind === 'none' });
  const rYearly = el('input', { type: 'radio', name: rName, value: 'yearly', checked: dueKind === 'yearly' });
  const rOnce = el('input', { type: 'radio', name: rName, value: 'once', checked: dueKind === 'once' });
  const yearlyBox = el('span', { class: 'due-opt', style: 'display:inline-flex;gap:6px;align-items:center' }, f.dueDay, f.dueMonth);
  const onceBox = el('span', { class: 'due-opt', style: 'display:inline-flex;gap:6px;align-items:center' }, f.dueDate);
  const kindOf = () => rYearly.checked ? 'yearly' : (rOnce.checked ? 'once' : 'none');
  const syncDue = () => {
    yearlyBox.style.display = rYearly.checked ? 'inline-flex' : 'none';
    onceBox.style.display = rOnce.checked ? 'inline-flex' : 'none';
  };
  [rNone, rYearly, rOnce].forEach((r) => r.addEventListener('change', syncDue));
  syncDue();
  const dueHelp = el('div', { style: 'font-size:12px;color:var(--muted);margin:-6px 0 10px' },
    hint ? 'Срокът е разпознат от текста „' + it.section + '" — проверете го.' : '');
  const body = el('div', {},
    field('Раздел', f.section), field('Точка', f.text),
    el('div', { class: 'field' }, el('label', { text: 'Падеж (по избор)' }),
      el('div', { class: 'due-radios', role: 'radiogroup', 'aria-label': 'Вид на срока' },
        el('label', {}, rNone, el('span', { text: 'Без срок' })),
        el('label', {}, rYearly, el('span', { text: 'Всяка година на:' }), yearlyBox),
        el('label', {}, rOnce, el('span', { text: 'Еднократно на:' }), onceBox))),
    dueHelp,
    field('Бележка', f.note), field('Свързан калкулатор', f.calc));
  if (existing && existing.id) { const _ab = auditBlock(existing); if (_ab) body.appendChild(_ab); }
  const save = async () => {
    const p = {
      company_id: state().activeCompany, year: _checkYear, section: f.section.value,
      text: f.text.value, note: f.note.value, calc: f.calc.value,
      // Записва се само избраният ВИД срок — останалите полета не пътуват.
      due_day: kindOf() === 'yearly' ? (Number(f.dueDay.value) || null) : null,
      due_month: kindOf() === 'yearly' ? (Number(f.dueMonth.value) || null) : null,
      due_date: kindOf() === 'once' ? (f.dueDate.dataset.iso || '') : '',
    };
    if (!p.text.trim()) { toast('Въведете текст на точката.', true); return; }
    if (kindOf() === 'yearly' && (!p.due_day || !p.due_month)) { toast('За годишния срок попълнете и ден, и месец.', true); return; }
    if (kindOf() === 'once' && !p.due_date) { toast('Изберете датата на еднократния срок.', true); return; }
    try {
      if (existing && existing.id) await api('/checklist/' + existing.id, { method: 'PUT', body: JSON.stringify(p) });
      else await api('/checklist', { method: 'POST', body: JSON.stringify(p) });
      closeModal(); toast('Записано.'); view($('#page'));
    } catch (e) { toast(e.message, true); }
  };
  const foot = el('div', {});
  if (existing && existing.id && isAdminUser()) foot.appendChild(el('button', { class: 'btn sm danger', text: 'Изтрий', style: 'margin-right:auto', onClick: async () => { if (await confirmDialog('Да изтрия ли тази точка?', { okText: 'Изтрий', danger: true })) { try { await api('/checklist/' + existing.id, { method: 'DELETE' }); closeModal(); view($('#page')); } catch (e) { toast('Изтриването не се получи. ' + e.message, true); } } } }));
  foot.appendChild(el('button', { class: 'btn ghost', text: 'Отказ', onClick: closeModal }));
  foot.appendChild(el('button', { class: 'btn', text: 'Запази', onClick: save }));
  openModal({ title: existing && existing.id ? 'Редакция на точка' : 'Нова точка', body, foot });
}



// (Б.6) Второто натискане добавяше всичките точки ВТОРИ път — чек листът
// ставаше двоен и не се разбираше кое е свършено. Сега се добавят само
// ЛИПСВАЩИТЕ (сравнение по раздел+текст за СЪЩАТА година), а пълното
// повторно зареждане иска изрично „да" с предупреждение за дублирането.
// existing = точките, които екранът вече е заредил.
const _normTxt = (v) => String(v || '').trim().toLowerCase().replace(/\s+/g, ' ');
const _tplKey = (section, text) => _normTxt(section) + '||' + _normTxt(text);

async function loadChecklistTemplate(existing) {
  if (!CHECKLIST_TEMPLATE.length) return;
  const have = new Set((existing || []).filter((it) => String(it.year) === String(_checkYear)).map((it) => _tplKey(it.section, it.text)));
  const missing = CHECKLIST_TEMPLATE.map((t, i) => ({ t, i })).filter((x) => !have.has(_tplKey(x.t.section, x.t.text)));

  let toAdd = missing;
  if (!missing.length) {
    // Всичко от шаблона вече го има. Дублирането е законно желание (нов
    // цикъл по същите точки), но трябва да е ИЗРИЧНО.
    if (!(await confirmDialog('Шаблонът вече е зареждан за ' + _checkYear + ' г. — всичките ' + CHECKLIST_TEMPLATE.length + ' точки вече ги има. Да го добавя ли ВТОРИ път (точките ще се дублират)?', { okText: 'Добави втори път', danger: true }))) return;
    toAdd = CHECKLIST_TEMPLATE.map((t, i) => ({ t, i }));
  } else if (missing.length < CHECKLIST_TEMPLATE.length) {
    if (!(await confirmDialog('От шаблона за ' + _checkYear + ' г. липсват ' + missing.length + ' точки (останалите вече ги има). Да добавя ли само липсващите?', { okText: 'Добави' }))) return;
  } else {
    if (!(await confirmDialog('Да заредя ли готовия шаблон за годишно приключване (' + CHECKLIST_TEMPLATE.length + ' точки) за година ' + _checkYear + '? Точките се добавят към съществуващите.', { okText: 'Зареди' }))) return;
  }

  toast('Зареждам шаблона…');
  let ok = 0, fail = 0;
  for (const x of toAdd) {
    try { await api('/checklist', { method: 'POST', body: JSON.stringify({ company_id: state().activeCompany, year: _checkYear, section: x.t.section, text: x.t.text, calc: x.t.calc || '', sort: x.i }) }); ok++; } catch (e) { fail++; }
  }
  toast('Добавени: ' + ok + (fail ? (', грешки: ' + fail) : '') + '.');
  view($('#page'));
}


